import { render, staticRenderFns } from "./ProfitRateOnSales.vue?vue&type=template&id=4938a4d2&scoped=true&"
import script from "./ProfitRateOnSales.vue?vue&type=script&lang=js&"
export * from "./ProfitRateOnSales.vue?vue&type=script&lang=js&"
import style0 from "./ProfitRateOnSales.vue?vue&type=style&index=0&id=4938a4d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4938a4d2",
  null
  
)

export default component.exports